import { toPng } from 'html-to-image';

/**
 * Filters out UI elements that should not be included in exports
 */
const shouldIncludeNode = (node: any): boolean => {
  if (!node?.classList) return true;

  const excludedClasses = [
    'react-flow__minimap',
    'react-flow__controls',
    'react-flow__node-toolbar',
    'react-flow__resize-control',
    'standard-node-noti',
    'standard-node-edit-edge',
    'flow-menu',
  ];

  return !excludedClasses.some((className) =>
    node.classList.contains(className),
  );
};

/**
 * Exports an HTML element to PNG image data URL
 */
export async function exportImage({
  element,
  pixelRatio = 4,
}: {
  element: HTMLElement;
  pixelRatio: number;
}): Promise<string> {
  const dataUrl = await toPng(element, {
    filter: shouldIncludeNode,
    backgroundColor: 'white',
    quality: 1,
    pixelRatio,
    skipFonts: true,
  });
  return dataUrl;
}

/**
 * Downloads an image from a data URL
 */
export function downloadImageFromDataUrl(
  dataUrl: string,
  filename: string,
): void {
  const a = document.createElement('a');
  a.setAttribute('download', filename);
  a.setAttribute('href', dataUrl);
  a.click();
}
